module.exports = __webpack_public_path__ + "static/media/filter-small.3bb53fd5.svg";